import { FC } from 'react';
// components
import EditExcipientTypeComponent from 'components/main/ExcipientType/Edit';

const EditExcipient: FC = () => <EditExcipientTypeComponent />;

export default EditExcipient;
